module.exports = __webpack_public_path__ + "img/icon-professionals.4909846e.png";